<button mat-icon-button aria-label="Settings" (click)="onClick($event)" [disabled]="! enabled" matTooltip="Settings">
    <mat-icon>{{ icon }}</mat-icon>
</button>